import React from "react";
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { Plan } from "@/types/plan";

interface PlansTableProps {
  plans: Plan[];
  onEdit: (plan: Plan) => void;
}

export const PlansTable = ({ plans, onEdit }: PlansTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nome do Plano</TableHead>
          <TableHead>Valor</TableHead>
          <TableHead>Recorrência</TableHead>
          <TableHead>Habilita Agente</TableHead>
          <TableHead>Ações</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {plans.map((plan) => (
          <TableRow key={plan.id}>
            <TableCell>{plan.name}</TableCell>
            <TableCell>{plan.price}</TableCell>
            <TableCell>{plan.recurrence}</TableCell>
            <TableCell>{plan.enable_agent}</TableCell>
            <TableCell>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(plan)}
              >
                <Edit className="h-4 w-4" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};